import { clearAuthHeaders } from "@/api/service"
import { TG_USER_ID_STORAGE_KEY } from "@/helpers/tgSession"

export const clearAuthData = () => {
  clearAuthHeaders()
  localStorage.removeItem(TG_USER_ID_STORAGE_KEY)
  localStorage.removeItem("userId")
  localStorage.removeItem("last-update-read")
}
